<template>
  <div class="LessonEntityDetails__Component">
    <b-switch @input="onChange" v-model="model.status">{{
      model.status ? "פעיל" : "לא פעיל"
    }}</b-switch>
    <FieldInlineText label="שם יחידת הלימוד" @onChange="onChange" v-model="model.name" />
    <!-- <FieldInlineSelect label="סוג" @onChange="onChange" :filterable="false" :clearable="false" :options="[{ Value: '0', Text: 'תרגול' },
    { Value: 1, Text: 'וידאו' },
    { Value: 2, Text: 'סימולציה' },]" v-model="model.lessonType" /> -->
    <FieldInlineSelect label="סוג" @onChange="onChange" :filterable="true" :clearable="false" :optionsAsync="getLessonTypes"
    v-model="model.lessonType" />
    <FieldInlineText :type="'number'" label="סדר" @onChange="onChange" v-model="model.sortOrder" />
    <b-field label="פתיח">
      <!-- <ckeditor @input="onChange" :editor="editor" placeholder="'פתיח'" v-model="model.supportingMaterials" :config="editorConfig"></ckeditor> -->
      <NewActivityEditor @onEditorChange="onEditorChange" :ckEditorContent="model.supportingMaterials" :content="model.supportingMaterials" ref="editor" />
    </b-field>
    <input type="color" @input="onChange" v-model="model.btnColor">
    <div style="margin-top: 15px;">
      <b-switch @input="onChange" v-model="model.isHidden">{{
        model.isHidden ? "מוסתר" : "לא מוסתר"
      }}</b-switch>
    </div>
    <FieldInlineSelect label="נושא ברירת מחדל לתרגולים" @onChange="onChange" :filterable="true" :clearable="false" :optionsAsync="getExerciseCategories"
    v-model="model.defaultExerciseCategoryId"/>
  </div>
</template>

<script>
import FieldInlineText from '@/components/Fields/FieldInlineText.vue';
// import FieldInlineTextArea from '@/components/Fields/FieldInlineTextArea.vue';
// import FieldInlineDate from '@/components/Fields/FieldInlineDate.vue';
// import FieldInlineDateTime from '@/components/Fields/FieldInlineDateTime.vue';
import FieldInlineSelect from '@/components/Fields/FieldInlineSelect.vue';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { mapGetters, mapMutations } from 'vuex';
import CoursesService from '../services/CoursesService';
import LessonService from '../services/LessonService';
import NewActivityEditor from './NewActivityEditor.vue';

const {
    ClassicEditor,
    Alignment,
    // Autoformat, // Disabled to fix asterisk auto-formatting
    Base64UploadAdapter,
    AutoImage,
    AutoLink,
    Autosave,
    BalloonToolbar,
    BlockQuote,
    Bold,
    Bookmark,
    CloudServices,
    Code,
    Essentials,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    Highlight,
    HorizontalLine,
    HtmlComment,
    HtmlEmbed,
    ImageBlock,
    ImageCaption,
    ImageInline,
    ImageInsertViaUrl,
    ImageResize,
    ImageStyle,
    ImageTextAlternative,
    ImageToolbar,
    ImageUpload,
    Indent,
    IndentBlock,
    Italic,
    Link,
    LinkImage,
    List,
    ListProperties,
    //
    MediaEmbed,
    Paragraph,
    PasteFromMarkdownExperimental,
    PasteFromOffice,
    RemoveFormat,
    SpecialCharacters,
    SpecialCharactersArrows,
    SpecialCharactersCurrency,
    SpecialCharactersEssentials,
    SpecialCharactersLatin,
    SpecialCharactersMathematical,
    SpecialCharactersText,
    Strikethrough,
    Style,
    Subscript,
    Superscript,
    Table,
    TableCaption,
    TableCellProperties,
    TableColumnResize,
    TableProperties,
    TableToolbar,
    TextTransformation,
    TodoList,
    Underline,
    FindAndReplace,
    PageBreak,
    ShowBlocks,
    WordCount
} = CKEDITOR;

const { ExportPdf, ExportWord, LineHeight } = CKEDITOR_PREMIUM_FEATURES;

export default {
  name: 'LessonEntityDetails',
  components: {
    FieldInlineText,
    // FieldInlineDate,
    FieldInlineSelect,
    NewActivityEditor
    // FieldInlineTextArea,
  },
  props: ['readOnly'],
  data() {
    return {
      model: {
        name: null,
        lessonType: null,
        status: null,
        sortOrder: null,
        btnColor: null,
        isHidden: null,
        defaultExerciseCategoryId: null,
      },
      editor: ClassicEditor,
      editorConfig: {
                language: 'he',
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'fontSize',
                        'fontFamily',
                        'fontColor',
                        'fontBackgroundColor',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        'caseChange',
                        'formatPainter',
                        '|',
                        'link',
                        'insertTable',
                        'highlight',
                        'pageBreak',
                        '|',
                        'alignment',
                        '|',
                        'bulletedList',
                        'numberedList',
                        'todoList',
                        'multilevelList',
                        'outdent',
                        'indent',
                        '|',
                        'findAndReplace',
                        'tableOfContents',
                        'showBlocks',
                        '|',
                        'exportPdf',
                        'exportWord'
                    ],
                    shouldNotGroupWhenFull: false
                },
                plugins: [
                    Alignment,
                    // Autoformat, // Disabled to fix asterisk auto-formatting
                    Base64UploadAdapter,
                    AutoImage,
                    AutoLink,
                    Autosave,
                    BalloonToolbar,
                    BlockQuote,
                    Bold,
                    Bookmark,
                    CloudServices,
                    Code,
                    Essentials,
                    FontBackgroundColor,
                    FontColor,
                    FontFamily,
                    FontSize,
                    GeneralHtmlSupport,
                    Heading,
                    Highlight,
                    HorizontalLine,
                    HtmlComment,
                    HtmlEmbed,
                    ImageBlock,
                    ImageCaption,
                    ImageInline,
                    ImageInsertViaUrl,
                    ImageResize,
                    ImageStyle,
                    ImageTextAlternative,
                    ImageToolbar,
                    ImageUpload,
                    Indent,
                    IndentBlock,
                    Italic,
                    Link,
                    LinkImage,
                    List,
                    ListProperties,
                    //
                    MediaEmbed,
                    Paragraph,
                    PasteFromMarkdownExperimental,
                    PasteFromOffice,
                    RemoveFormat,
                    SpecialCharacters,
                    SpecialCharactersArrows,
                    SpecialCharactersCurrency,
                    SpecialCharactersEssentials,
                    SpecialCharactersLatin,
                    SpecialCharactersMathematical,
                    SpecialCharactersText,
                    Strikethrough,
                    Style,
                    Subscript,
                    Superscript,
                    Table,
                    TableCaption,
                    TableCellProperties,
                    TableColumnResize,
                    TableProperties,
                    TableToolbar,
                    TextTransformation,
                    TodoList,
                    Underline,
                    ExportPdf,
                    ExportWord,
                    LineHeight,
                    FindAndReplace,
                    PageBreak,
                    ShowBlocks,
                    WordCount,
                ].filter(Boolean),
                balloonToolbar: ['bold', 'italic', '|', 'link', '|', 'bulletedList', 'numberedList'],
                fontFamily: {
                    supportAllValues: true
                },
                fontSize: {
                    options: [10, 12, 14, 'default', 18, 20, 22],
                    supportAllValues: true
                },
                lineHeight: {
                    options: ['default', 1, 1.1, 1.25, 1.5, 2, 2.5, 3]
                },
                heading: {
                    options: [
                        {
                            model: 'paragraph',
                            title: 'Paragraph',
                            class: 'ck-heading_paragraph'
                        },
                        {
                            model: 'heading1',
                            view: 'h1',
                            title: 'Heading 1',
                            class: 'ck-heading_heading1'
                        },
                        {
                            model: 'heading2',
                            view: 'h2',
                            title: 'Heading 2',
                            class: 'ck-heading_heading2'
                        },
                        {
                            model: 'heading3',
                            view: 'h3',
                            title: 'Heading 3',
                            class: 'ck-heading_heading3'
                        },
                        {
                            model: 'heading4',
                            view: 'h4',
                            title: 'Heading 4',
                            class: 'ck-heading_heading4'
                        },
                        {
                            model: 'heading5',
                            view: 'h5',
                            title: 'Heading 5',
                            class: 'ck-heading_heading5'
                        },
                        {
                            model: 'heading6',
                            view: 'h6',
                            title: 'Heading 6',
                            class: 'ck-heading_heading6'
                        }
                    ]
                },
                htmlSupport: {
                    allow: [
                        {
                            name: /^.*$/,
                            styles: true,
                            attributes: true,
                            classes: true
                        }
                    ]
                },
                image: {
                    toolbar: [
                        'toggleImageCaption',
                        'imageTextAlternative',
                        '|',
                        'imageStyle:inline',
                        'imageStyle:wrapText',
                        'imageStyle:breakText',
                        '|',
                        'resizeImage'
                    ]
                },
                licenseKey: process.env.VUE_APP_CKEDITOR_LICENSE_KEY,
                exportPdf: {
                    stylesheets: [
                        'https://cdn.ckeditor.com/ckeditor5/44.1.0/ckeditor5.css',
                        'https://cdn.ckeditor.com/ckeditor5-premium-features/44.1.0/ckeditor5-premium-features.css'
                    ],
                    fileName: 'document.pdf',
                    converterOptions: {
                        format: 'A4',
                        margin_top: '20mm',
                        margin_bottom: '20mm',
                        margin_right: '12mm',
                        margin_left: '12mm',
                        page_orientation: 'portrait'
                    }
                },
                exportWord: {
                    stylesheets: [
                        'https://cdn.ckeditor.com/ckeditor5/44.1.0/ckeditor5.css',
                        'https://cdn.ckeditor.com/ckeditor5-premium-features/44.1.0/ckeditor5-premium-features.css'
                    ],
                    fileName: 'document.docx',
                    converterOptions: {
                        format: 'A4',
                        margin_top: '20mm',
                        margin_bottom: '20mm',
                        margin_right: '12mm',
                        margin_left: '12mm',
                        orientation: 'portrait'
                    }
                },
                link: {
                    addTargetToExternalLinks: true,
                    defaultProtocol: 'https://',
                    decorators: {
                        toggleDownloadable: {
                            mode: 'manual',
                            label: 'Downloadable',
                            attributes: {
                                download: 'file'
                            }
                        }
                    }
                },
                list: {
                    properties: {
                        styles: true,
                        startIndex: true,
                        reversed: true
                    }
                },
                menuBar: {
                    isVisible: true
                },
                placeholder: '',
                style: {
                    definitions: [
                        {
                            name: 'Article category',
                            element: 'h3',
                            classes: ['category']
                        },
                        {
                            name: 'Title',
                            element: 'h2',
                            classes: ['document-title']
                        },
                        {
                            name: 'Subtitle',
                            element: 'h3',
                            classes: ['document-subtitle']
                        },
                        {
                            name: 'Info box',
                            element: 'p',
                            classes: ['info-box']
                        },
                        {
                            name: 'Side quote',
                            element: 'blockquote',
                            classes: ['side-quote']
                        },
                        {
                            name: 'Marker',
                            element: 'span',
                            classes: ['marker']
                        },
                        {
                            name: 'Spoiler',
                            element: 'span',
                            classes: ['spoiler']
                        },
                        {
                            name: 'Code (dark)',
                            element: 'pre',
                            classes: ['fancy-code', 'fancy-code-dark']
                        },
                        {
                            name: 'Code (bright)',
                            element: 'pre',
                            classes: ['fancy-code', 'fancy-code-bright']
                        }
                    ]
                },
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
                }
            },
    };
  },
  computed: {
    ...mapGetters('lesson', [
      'form',
    ]),
    courseId() {
      return this.$store.state.auth.course.id;
    },
    changesAmount() {
      return Object.keys(this.diff(this.model, this.form)).length;
    },
  },
  created() {
    this.model = { ...this.model, ...this.form };
    if (this.model.lessonType === 0) {
      this.model.lessonType = { Text: 'תרגול', Value: 0 };
    }
    if (this.model.btnColor) {
      [this.model.btnColor] = this.model.btnColor?.split(';');
    }
  },
  methods: {
    diff(o1, o2) {
      const diff = Object.keys(o2).reduce((diff1, key) => {
        if (o1[key] && typeof o1[key].getMonth === 'function') {
          if (new Date(o1[key]).toString() === new Date(o2[key]).toString()) return diff1;
        }
        if (typeof o1[key] === 'number') {
          if (parseInt(o1[key], 10) === parseInt(o2[key], 10)) return diff1;
        }
        if (o1[key] && typeof o1[key] === 'object' && typeof o1[key].getMonth !== 'function') {
          if (o1[key]?.Id === o2[key]?.Id) return diff1;
        }
        if (o1[key] === o2[key]) return diff1;
        return {
          ...diff1,
          [key]: o2[key],
        };
      }, {});

      return diff;
    },
    getLessonTypes() {
      return () =>
        LessonService.getLessonTypes().then((r) =>
          r.data.map((i) => ({ Value: i.id, Text: `${i.name}` }))
        );
    },
    getExerciseCategories() {
      return () =>
        CoursesService.getCategories().then((r) =>
          r.data.map((i) => ({ Value: i.id, Text: `${i.name}` }))
        );
    },
    onChange() {
      this.$emit('onFormChange', this.changesAmount);
    },
    onEditorChange(value) {
      this.model.supportingMaterials = value;
      this.$emit('onFormChange', this.changesAmount);
    },
    cancel() {
      this.model = { ...this.model, ...this.form };
    },
    save() {
      this.$emit('onFormSave', {
        model: this.model,
        cancel: this.cancel,
        setRestorePoint: this.setRestorePoint,
      });
    },
    setRestorePoint() {
      this.storeLessonDetails(this.model);
    },
    refresh() {
      this.model = { ...this.model, ...this.form };
    },
    ...mapMutations('lesson', [
      'storeLessonDetails',
    ]),
  },
};
</script>

<style></style>
